import HeadData from 'components/Common/HeadData'
import { OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import { descriptionBuilder } from 'lib/offer/descriptionBuilder'
import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'
import React from 'react'
import OfferGoogleProductDataScript from './OfferGoogleProductDataScript'
import config from 'constants/config'
import HotelStructuredData from './HotelStructuredData'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import { getImageUrl } from 'lib/image/imageUtils'

interface Props {
  offer: App.Offer;
  canonicalPath?: string;
  /**
   * There are exclusive LuxPlus+ offers. They should
   * appear as hidden offers to non-members
   */
  isLuxPlusHiddenOffer?: boolean;
}

function OfferPageHeadData(props: Props) {
  const { offer, canonicalPath, isLuxPlusHiddenOffer } = props

  const availableForPurchase = scheduleIsCurrent(offer.onlinePurchaseSchedule)
  const metaDescription = descriptionBuilder(
    offer.name,
    offer?.lowestPricePackage?.price ?? 0,
    offer?.lowestPricePackage?.value ?? 0,
    config.BRAND,
    config.title,
  )

  let canonicalTag = ''

  if (config.ENABLE_ONE_PROPERTY_PAGE && offer.property) {
    canonicalTag = `/property/${offer.slug}-le:${offer.property.id}`
  } else {
    canonicalTag = `/offer/${offer.slug}/${offer.id}`
  }

  let title = ''
  let description = ''
  let imageUrl = ''

  if (isLuxPlusHiddenOffer) {
    title = `${LUXURY_PLUS.PROGRAM_NAME} Member Exclusive`
    description = `Unlock hidden hotel offers available exclusively for ${LUXURY_PLUS.PROGRAM_NAME} members. These escapes aren't available anywhere else`
    imageUrl = offer.images[0].id ? getImageUrl(offer.images[0].id, { width: 65, format: 'jpeg', quality: 'low' }) : ''
  } else {
    title = [offer.name, offer.locationHeading, offer.locationSubheading].filter(t => t).join(', ')
    description = metaDescription
    imageUrl = offer.images[0].id ? getImageUrl(offer.images[0].id, { width: 650, format: 'jpeg' }) : ''
  }

  return (
    <>
      <HeadData
        title={title}
        description={description}
        noIndex={offer.noIndex || !availableForPurchase}
        canonical={canonicalPath ?? canonicalTag}
        imageId={offer.images[0].id}
        imageUrl={imageUrl}
      />
      {offer.property && <HotelStructuredData offer={offer} />}
      {offer.type !== OFFER_TYPE_LAST_MINUTE && (
        <OfferGoogleProductDataScript
          availableForPurchase={availableForPurchase}
          offer={offer}
        />
      )}
    </>
  )
}

export default OfferPageHeadData
